// Configuration for the application
export const config = {
  // Base URL for the application - use custom domain for production
  baseUrl: 'https://yoursongrequest.com',
  
  // Function to get the base URL (useful for development vs production)
  getBaseUrl: () => {
    // CRITICAL: Always enforce HTTPS and prevent .web.app URLs
    let url;
    
    // In development, use window.location.origin (but ensure HTTPS)
    if (process.env.NODE_ENV === 'development') {
      const origin = window.location.origin;
      // Ensure HTTPS protocol even in development if not localhost
      if (origin.startsWith('http://') && !origin.includes('localhost')) {
        url = origin.replace('http://', 'https://');
      } else {
        url = origin;
      }
    } else {
      // In production, ALWAYS use the custom domain with HTTPS
      // CRITICAL: Never use .web.app URLs - always use custom domain
      // This prevents mixed content warnings from Firebase hosting URLs
      url = 'https://yoursongrequest.com';
    }
    
    // CRITICAL: Sanitize URL to prevent mixed content errors
    // Remove any .web.app references
    if (url.includes('.web.app')) {
      console.error('❌ ERROR: Base URL contains .web.app - forcing custom domain!');
      url = 'https://yoursongrequest.com';
    }
    
    // Ensure HTTPS protocol (double-check)
    if (url.startsWith('http://')) {
      console.warn('⚠️ WARNING: Base URL uses HTTP - forcing HTTPS!');
      url = url.replace('http://', 'https://');
    }
    
    // Final validation
    if (!url.startsWith('https://')) {
      console.error('❌ ERROR: Base URL does not use HTTPS - forcing HTTPS!');
      url = 'https://yoursongrequest.com';
    }
    
    return url;
  },
  
  // Helper function to ensure HTTPS for any URL
  // CRITICAL: Prevents mixed content errors by forcing HTTPS
  ensureHttps: (url) => {
    if (!url) return url;
    if (typeof url !== 'string') return url;
    
    // Remove any .web.app references to prevent mixed content
    if (url.includes('.web.app')) {
      console.warn('⚠️ WARNING: URL contains .web.app - replacing with custom domain');
      url = url.replace(/\.web\.app/g, '.yoursongrequest.com');
      // If it was just the domain, ensure it's the custom domain
      if (url.includes('yoursongrequest-fe6e9.yoursongrequest.com')) {
        url = url.replace('yoursongrequest-fe6e9.yoursongrequest.com', 'yoursongrequest.com');
      }
    }
    
    // Force HTTPS protocol
    if (url.startsWith('http://')) {
      console.warn('⚠️ WARNING: URL uses HTTP - forcing HTTPS');
      url = url.replace('http://', 'https://');
    }
    
    return url;
  },
  
  // Google Maps API Key - should be set in environment variables
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || 'YOUR_GOOGLE_MAPS_API_KEY',
  
  // App configuration
  app: {
    name: 'Your Song Request',
    version: '1.0.0',
    environment: import.meta.env.MODE || 'development'
  }
};

// Google Maps utility functions
export const getGoogleStaticMapUrl = (latitude, longitude, zoom = 15, size = '400x300') => {
  const apiKey = config.googleMapsApiKey;
  if (!apiKey || apiKey === 'YOUR_GOOGLE_MAPS_API_KEY') {
    console.warn('Google Maps API key not configured');
    return null;
  }
  
  return `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=${zoom}&size=${size}&key=${apiKey}`;
};

export const getGoogleMapsEmbedUrl = (latitude, longitude, zoom = 15) => {
  const apiKey = config.googleMapsApiKey;
  if (!apiKey || apiKey === 'YOUR_GOOGLE_MAPS_API_KEY') {
    console.warn('Google Maps API key not configured');
    return null;
  }
  
  return `https://www.google.com/maps/embed/v1/view?key=${apiKey}&center=${latitude},${longitude}&zoom=${zoom}`;
};

export default config;